/** Single registry for monthly weights + indicator tables. Add a row to introduce a component. */
export const COMMISSION_COMPONENTS = [
  {
    key: "sale_target",
    fa: "تارگت فروش",
    tableKey: "volume_target",
    tableTitle: "نحوه محاسبه درصد تحقق تارگت حجمی",
    entryGated: false,
    defaultWeight: 40,
    icon: "📊",
  },
  {
    key: "active_target",
    fa: "تارگت اکتیو مشتریان",
    tableKey: "active_target",
    tableTitle: "نحوه محاسبه درصد تحقق تارگت اکتیو مشتریان",
    entryGated: true,
    defaultWeight: 20,
    icon: "👥",
  },
  {
    key: "return_pct",
    fa: "درصد مرجوعی",
    tableKey: "return_pct",
    tableTitle: "نحوه محاسبه درصد مرجوعی",
    entryGated: true,
    queryPicker: true,
    defaultWeight: 20,
    icon: "↩️",
  },
  {
    key: "claims",
    fa: "مطالبات",
    tableKey: "claims",
    tableTitle: "درصد مطالبات",
    entryGated: true,
    defaultWeight: 20,
    icon: "💳",
  },
];

export const INDICATOR_TABLE_ORDER = COMMISSION_COMPONENTS.map((c) => c.tableKey);
export const ENTRY_GATED_KEYS = COMMISSION_COMPONENTS.filter((c) => c.entryGated).map((c) => c.key);
export const GATED_COMPONENT_LABELS = COMMISSION_COMPONENTS.filter((c) => c.entryGated)
  .map((c) => c.fa)
  .join("، ");

export const RETURN_QUERY_OPTIONS = [
  { key: "return_percentage_gross_carton", fa: "درصد مرجوعی کارتن ناخالص (ناخالص − خالص) / ناخالص" },
  { key: "return_percentage_pack_qty", fa: "درصد مرجوعی کارتن (pack_qty)" },
  { key: "return_percentage_qty", fa: "درصد مرجوعی ظرف (qty)" },
  { key: "return_percentage_weight", fa: "درصد مرجوعی وزن (kg)" },
];

export const MIN_OPS = [
  { value: "", label: "—" },
  { value: "gte", label: "≥" },
  { value: "gt", label: ">" },
];

export const MAX_OPS = [
  { value: "", label: "—" },
  { value: "lte", label: "≤" },
  { value: "lt", label: "<" },
];

export function emptyGroupPercents() {
  return { basket_percent: "", excess_percent: "", max_payout_percent: "" };
}

export function readGroupCommissionMap(profile) {
  const map = {};
  const rows = profile?.customization?.product_group_commission;
  if (Array.isArray(rows)) {
    rows.forEach((row) => {
      if (row?.id == null) return;
      map[row.id] = {
        basket_percent: row.basket_percent ?? "",
        excess_percent: row.excess_percent ?? "",
        max_payout_percent:
          row.max_payout_percent == null ? "" : row.max_payout_percent,
      };
    });
  }
  return map;
}

export function defaultMonthlyCommission() {
  return {
    approved_amount: "",
    components: COMMISSION_COMPONENTS.map((c) => ({
      key: c.key,
      enabled: true,
      weight: c.defaultWeight,
    })),
  };
}

export function readMonthlyCommission(profile) {
  const raw = profile?.customization?.monthly_commission;
  const defaults = defaultMonthlyCommission();
  if (!raw || typeof raw !== "object") return defaults;
  const byKey = new Map((raw.components || []).map((row) => [row.key, row]));
  return {
    approved_amount:
      raw.approved_amount == null || raw.approved_amount === ""
        ? ""
        : raw.approved_amount,
    components: COMMISSION_COMPONENTS.map((c) => {
      const row = byKey.get(c.key);
      return {
        key: c.key,
        enabled: row ? row.enabled !== false : true,
        weight: row?.weight ?? c.defaultWeight,
      };
    }),
  };
}

export function sumNumbers(values) {
  return values.reduce((sum, v) => {
    const n = parseFloat(v);
    return sum + (Number.isFinite(n) ? n : 0);
  }, 0);
}

export function almostEqual(a, b, eps = 0.05) {
  return Math.abs(a - b) <= eps;
}

export function bandMinOp(band) {
  if (band?.min == null || band.min === "") return "";
  return band.min_inclusive === false ? "gt" : "gte";
}

export function bandMaxOp(band) {
  if (band?.max == null || band.max === "") return "";
  return band.max_inclusive === true ? "lte" : "lt";
}

export function emptyBand() {
  return {
    id: `band_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    min: null,
    max: null,
    min_inclusive: true,
    max_inclusive: false,
    payout_percent: 0,
  };
}

export function patchBand(band, field, value) {
  const next = { ...band };
  if (field === "minOp") {
    if (!value) {
      next.min = null;
    } else {
      next.min_inclusive = value !== "gt";
      if (next.min == null) next.min = 0;
    }
    return next;
  }
  if (field === "maxOp") {
    if (!value) {
      next.max = null;
    } else {
      next.max_inclusive = value === "lte";
      if (next.max == null) next.max = 0;
    }
    return next;
  }
  if (field === "min" || field === "max" || field === "payout_percent") {
    next[field] = value === "" ? null : Number(value);
    return next;
  }
  next[field] = value;
  return next;
}
